module.exports = __webpack_public_path__ + "static/media/heic-simple-icon.6457d262.svg";